'use client';

import { c as _c } from "react/compiler-runtime";
import { cn } from '@core/utils';
import type { CartProductGroup, OptionChangeParams } from '../../_types';
import { AddGiftButton } from './AddGiftButton';
import { CartGroupHeader } from './CartGroupHeader';
import { CartItem } from './CartItem';
interface CartGroupInstitution {
  id: number;
  name: string;
  logoUrl?: string;
}
export interface CartGroupProps {
  institution: CartGroupInstitution;
  productGroups: CartProductGroup[];
  selectedIds: Set<number>;
  onSelect: (giftCartItemOptionId: number) => void;
  onSelectAll: () => void;
  onChangeOption: (giftCartItemOptionId: number, changes: OptionChangeParams) => void;
  onDelete: (giftCartItemOptionId: number) => void;
  onDeleteProduct: (giftCartItemId: number) => void;
  onDeleteSelected: () => void;
  className?: string;
}
export const CartGroup = t0 => {
  const $ = _c(42);
  const {
    institution,
    productGroups,
    selectedIds,
    onSelect,
    onSelectAll,
    onChangeOption,
    onDelete,
    onDeleteProduct,
    onDeleteSelected,
    className
  } = t0;
  let isAllSelected;
  let t1;
  if ($[0] !== productGroups || $[1] !== selectedIds) {
    const allItems = productGroups.flatMap(_temp);
    let t2;
    if ($[4] !== selectedIds) {
      t2 = item => selectedIds.has(item.giftCartItemOptionId);
      $[4] = selectedIds;
      $[5] = t2;
    } else {
      t2 = $[5];
    }
    isAllSelected = allItems.every(t2);
    t1 = allItems.reduce(_temp2, 0);
    $[0] = productGroups;
    $[1] = selectedIds;
    $[2] = isAllSelected;
    $[3] = t1;
  } else {
    isAllSelected = $[2];
    t1 = $[3];
  }
  const totalQuantity = t1;
  const showBenefitTooltip = totalQuantity === 1;
  let t2;
  if ($[6] !== className) {
    t2 = cn("flex flex-col gap-16", className);
    $[6] = className;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[8] !== onDeleteSelected) {
    t3 = <button type="button" className="font-600 text-Gray-600 typo-body4 mobile-tablet:typo-caption2" onClick={onDeleteSelected} aria-label={"\uC120\uD0DD \uC0AD\uC81C"}>선택 삭제</button>;
    $[8] = onDeleteSelected;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] !== institution.logoUrl || $[11] !== institution.name || $[12] !== isAllSelected || $[13] !== onSelectAll || $[14] !== t3) {
    t4 = <CartGroupHeader logoUrl={institution.logoUrl} name={institution.name} isAllSelected={isAllSelected} onAllSelectChange={onSelectAll} right={t3} />;
    $[10] = institution.logoUrl;
    $[11] = institution.name;
    $[12] = isAllSelected;
    $[13] = onSelectAll;
    $[14] = t3;
    $[15] = t4;
  } else {
    t4 = $[15];
  }
  let t5;
  if ($[16] !== onChangeOption || $[17] !== onDelete || $[18] !== onDeleteProduct || $[19] !== onSelect || $[20] !== productGroups || $[21] !== selectedIds || $[22] !== showBenefitTooltip) {
    let t6;
    if ($[24] !== onChangeOption || $[25] !== onDelete || $[26] !== onDeleteProduct || $[27] !== onSelect || $[28] !== selectedIds || $[29] !== showBenefitTooltip) {
      t6 = (group_0, groupIndex) => <CartItem key={group_0.productNumber} group={group_0} selectedIds={selectedIds} onSelect={onSelect} onChangeOption={onChangeOption} onDelete={onDelete} onDeleteProduct={onDeleteProduct} showBenefitTooltip={showBenefitTooltip && groupIndex === 0} />;
      $[24] = onChangeOption;
      $[25] = onDelete;
      $[26] = onDeleteProduct;
      $[27] = onSelect;
      $[28] = selectedIds;
      $[29] = showBenefitTooltip;
      $[30] = t6;
    } else {
      t6 = $[30];
    }
    t5 = productGroups.map(t6);
    $[16] = onChangeOption;
    $[17] = onDelete;
    $[18] = onDeleteProduct;
    $[19] = onSelect;
    $[20] = productGroups;
    $[21] = selectedIds;
    $[22] = showBenefitTooltip;
    $[23] = t5;
  } else {
    t5 = $[23];
  }
  let t6;
  if ($[31] !== t5) {
    t6 = <ul className="flex flex-col gap-24 ">{t5}</ul>;
    $[31] = t5;
    $[32] = t6;
  } else {
    t6 = $[32];
  }
  let t7;
  if ($[33] !== institution.id) {
    t7 = <AddGiftButton institutionId={institution.id} className="mobile-tablet:mx-20" />;
    $[33] = institution.id;
    $[34] = t7;
  } else {
    t7 = $[34];
  }
  let t8;
  if ($[35] !== t6 || $[36] !== t7) {
    t8 = <div className="flex flex-col gap-20 rounded-xlarge bg-Gray-white p-20 py-16 mobile-tablet:p-0">{t6}{t7}</div>;
    $[35] = t6;
    $[36] = t7;
    $[37] = t8;
  } else {
    t8 = $[37];
  }
  let t9;
  if ($[38] !== t2 || $[39] !== t4 || $[40] !== t8) {
    t9 = <div className={t2}>{t4}{t8}</div>;
    $[38] = t2;
    $[39] = t4;
    $[40] = t8;
    $[41] = t9;
  } else {
    t9 = $[41];
  }
  return t9;
};
function _temp(group) {
  return group.items;
}
function _temp2(sum, item_0) {
  return sum + item_0.quantity;
}